// ======================================================================
// File Name       : DistributionManagerContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Col, Form, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import moment from 'moment';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import DistributionOfferListDetailTitle from '../../components/contentDistribution/DistributionOfferListDetailTitle';
import DistributionOfferListDetailContentType from '../../components/contentDistribution/DistributionOfferListDetailContentType';
import DistributionOfferListDetailCourseType from '../../components/contentDistribution/DistributionOfferListDetailCourseType';
import {
  getContentsList,
  getCourseListForDetail,
  getCourseList,
  editServiceDistribution,
  resetDistributionOfferListDetail,
} from '../../actions/ContentDistributionAction';
import { SELECT_TARGET_DATA, RETURN_MAX_NUM, DEFAULT_DATE_SHORT_FORMAT_SERVER, IS_SHOW_MENU_DEVELOP_FEATURE_51 } from '../../constants/index';
import { DISTRIBUTION_EDIT_TYPE } from '../../constants/ContentDistributionConstant';
import DialogConfirm from '../../components/DialogConfirm';
import * as MessageTemplate from '../../constants/MessageTemplate';
import { MIN_DATE, MAX_DATE, MIN_MAX_DATE_TXT } from '../../utils/index';
import Header from '../../components/Header';
import MessageSearch from '../../components/MessageSearch';
import { DISTRIBUTION_OFFER_TYPE } from '../../constants/ContentConstant';
import { canAccessRoute } from '../../utils/AuthedUtils';
import * as functionConstants from '../../constants/FunctionConstants';
import * as Path from '../../constants/PathConstants';
import * as actionType from '../../constants/actionTypes/page';
import CustomLink from '../../components/button/CustomLink';

class DistributionOfferListDetailContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      typeModal: null,
      distributionContentList: [],
      recordContentNum: 0,
      distributionCourseList: [],
      recordCourseNum: 0,
      serviceName: null,
      distributionStatus: null,
      serviceCd: null,
      searchInfo: {
        contentSecernId: '',
        contentName: '',
        contentType: '',
        courseName: '',
        distributionStartDate: moment(MIN_DATE).format(DEFAULT_DATE_SHORT_FORMAT_SERVER),
        distributionEndDate: moment(MAX_DATE).format(DEFAULT_DATE_SHORT_FORMAT_SERVER),
        distributionContentSortType: null,
        distributionCourseSortType: null,
        ascendingDescendingSort: null,
        startPosition: 0,
        returnMaxNum: RETURN_MAX_NUM,
        offerType: IS_SHOW_MENU_DEVELOP_FEATURE_51 ?
        DISTRIBUTION_OFFER_TYPE.COURSE : DISTRIBUTION_OFFER_TYPE.CONTENT,
      },
      currentSearch: {
        contentSecernId: '',
        contentName: '',
        contentType: '',
        courseName: '',
        distributionStartDate: moment(MIN_DATE).format(DEFAULT_DATE_SHORT_FORMAT_SERVER),
        distributionEndDate: moment(MAX_DATE).format(DEFAULT_DATE_SHORT_FORMAT_SERVER),
        distributionContentSortType: null,
        distributionCourseSortType: null,
        ascendingDescendingSort: null,
        startPosition: 0,
        returnMaxNum: RETURN_MAX_NUM,
        offerType: IS_SHOW_MENU_DEVELOP_FEATURE_51 ?
        DISTRIBUTION_OFFER_TYPE.COURSE : DISTRIBUTION_OFFER_TYPE.CONTENT,
      },
      redirectToList: false,
      isAllowShowSearchMessage: false,
      isInit: true,
    };

    this.handleStartStopContent = this.handleStartStopContent.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleOfferTypeChange = this.handleOfferTypeChange.bind(this);
    this.handleSearchBtnClick = this.handleSearchBtnClick.bind(this);
    this.handleBackBtnClick = this.handleBackBtnClick.bind(this);
    this.openConfirmDialog = this.openConfirmDialog.bind(this);
    this.onDialogOkBtnClick = this.onDialogOkBtnClick.bind(this);
    this.onDialogCancelBtnClick = this.onDialogCancelBtnClick.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.validation = this.validation.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
  }

  componentWillMount() {
    const { match } = this.props;
    if (this.props.parentPathSub === Path.CONTENT_DISTRIBUTION_OFFER_LIST_DETAIL) {
      this.setState({
        ...this.state,
        currentSearch: this.props.searchConditionSub,
        searchInfo: this.props.searchConditionSub,
        isInit: true,
      });
    }
    if (match.params.id) {
      this.setState({
        serviceCd: match.params.id,
      }, () => {
        this.getDistributionList();
      });
    } else {
      this.props.history.push(Path.CONTENT_DISTRIBUTION_LIST);
    }
  }

  componentWillUnmount() {
    const searchConditionSub = this.state.currentSearch;
    const { dispatch } = this.props;
    if (searchConditionSub) {
      searchConditionSub.startPosition = this.state.searchInfo.startPosition;
      searchConditionSub.distributionContentSortType = this.state.searchInfo.distributionContentSortType;
      searchConditionSub.ascendingDescendingSort = this.state.searchInfo.ascendingDescendingSort;
      searchConditionSub.offerType = this.state.searchInfo.offerType;
    }
    this.props.dispatch({
      type: actionType.SAVE_SEARCH_CONDITION_SUB,
      parentPathSub: Path.CONTENT_DISTRIBUTION_OFFER_LIST_DETAIL,
      searchConditionSub,
    });
    dispatch(resetDistributionOfferListDetail());
  }

  getDistributionList() {
    const { offerType } = this.state.searchInfo;
    if (offerType === DISTRIBUTION_OFFER_TYPE.CONTENT) {
      this.getContentsList();
    } else if (offerType === DISTRIBUTION_OFFER_TYPE.COURSE) {
      this.getCourseList();
    }
  }

  /**
   * Get content list
   *
   */
  getContentsList(selectTargetData) {
    const { serviceCd } = this.state;
    const { auth, dispatch } = this.props;
    const { currentSearch } = this.state;
    currentSearch.startPosition = this.state.searchInfo.startPosition;
    currentSearch.distributionContentSortType = this.state.searchInfo.distributionContentSortType;
    currentSearch.ascendingDescendingSort = this.state.searchInfo.ascendingDescendingSort;
    if (!selectTargetData) {
      selectTargetData = SELECT_TARGET_DATA.DATA;
    }
    this.props.dispatch(getContentsList(auth, selectTargetData, currentSearch, serviceCd)).then(() => {
      if (!this.state.isInit) {
        this.setState({ isAllowShowSearchMessage: true });
      }
    }).catch(() => {
      this.setState({ isAllowShowSearchMessage: false });
    });
  }

  /**
   * Get course list
   *
   */
  getCourseList(selectTargetData) {
    const { serviceCd } = this.state;
    const { auth, dispatch } = this.props;
    const { currentSearch } = this.state;
    currentSearch.startPosition = this.state.searchInfo.startPosition;
    currentSearch.distributionCourseSortType = this.state.searchInfo.distributionCourseSortType;
    currentSearch.ascendingDescendingSort = this.state.searchInfo.ascendingDescendingSort;
    if (!selectTargetData) {
      selectTargetData = SELECT_TARGET_DATA.DATA;
    }
    this.props.dispatch(getCourseListForDetail(auth, selectTargetData, currentSearch, serviceCd)).then(() => {
      if (!this.state.isInit) {
        this.setState({ isAllowShowSearchMessage: true });
      }
    }).catch(() => {
      this.setState({ isAllowShowSearchMessage: false });
    });
  }

  componentWillReceiveProps(nextProps) {
    const {
      offerListDetail,
      deleteSuccess,
    } = nextProps.contentDistribution;
    if (deleteSuccess) {
      this.props.history.push(Path.CONTENT_DISTRIBUTION_LIST);
    }
    const {
      distributionContentList,
      serviceName,
      distributionStatus,
      recordContentNum,
      distributionCourseList,
      recordCourseNum,
    } = offerListDetail;
    this.setState({
      distributionContentList,
      serviceName,
      distributionStatus,
      recordContentNum,
      distributionCourseList,
      recordCourseNum,
    });
  }

  /**
 * Handle event when user change page on paging
 * @param page
 */
  getStartEndData(page) {
    if (!this.validation()) {
      return;
    }
    const searchInfo = { ...this.state.searchInfo };
    searchInfo.startPosition = page;
    this.setState({
      searchInfo,
      isInit: false,
    }, () => {
      this.getDistributionList();
    });
  }

  handleSearchBtnClick() {
    if (!this.validation()) {
      return;
    }
    const searchInfo = {
      ...this.state.searchInfo,
      distributionCourseSortType: null,
      distributionContentSortType: null,
      ascendingDescendingSort: null,
      startPosition: 0,
    };
    const currentSearch = {
      ...this.state.searchInfo,
      ...(this.state.currentSearch = searchInfo),
    };
    this.setState(
      {
        searchInfo,
        currentSearch,
        isAllowShowSearchMessage: false,
        isInit: false,
      }, () => {
      this.getDistributionList();
    });
  }

  handleBackBtnClick() {
    this.props.history.goBack();
  }

  handleStartStopContent() {
    const { auth, dispatch } = this.props;
    const { serviceCd } = this.state;
    let { distributionStatus } = this.state;
    if (distributionStatus) {
      distributionStatus = 0;
    } else {
      distributionStatus = 1;
    }
    this.props.dispatch(
      editServiceDistribution(auth, DISTRIBUTION_EDIT_TYPE.update, serviceCd, distributionStatus),
    ).then(() => {
      this.setState({ distributionStatus });
    });
  }

  handleInputChange(name, value) {
    const searchInfo = { ...this.state.searchInfo, ...{ [name]: value } };
    this.setState({
      searchInfo,
    });
  }

  handleOfferTypeChange(name, value) {
    // reset search info when change offer type
    const searchInfo = {
      ...this.state.searchInfo,
      contentSecernId: '',
      contentName: '',
      contentType: '',
      courseName: '',
      distributionStartDate: moment(MIN_DATE).format(DEFAULT_DATE_SHORT_FORMAT_SERVER),
      distributionEndDate: moment(MAX_DATE).format(DEFAULT_DATE_SHORT_FORMAT_SERVER),
      distributionContentSortType: null,
      distributionCourseSortType: null,
      ascendingDescendingSort: null,
      startPosition: 0,
      returnMaxNum: RETURN_MAX_NUM,
      offerType: parseInt(value, 10),
    };
    const currentSearch = {
      ...this.state.searchInfo,
      ...(this.state.currentSearch = searchInfo),
    };
    this.setState({
      searchInfo,
      currentSearch,
    }, () => {
      this.getDistributionList();
    });
  }

  openConfirmDialog(mdContent, mdSize, type) {
    this.content = mdContent;
    this.mdSize = mdSize;
    this.setState({ showModal: true, typeModal: type });
  }

  /**
     * Cancel delete SuperUser
     */
  onDialogCancelBtnClick() {
    this.setState({ showModal: false, typeModal: null });
  }

  /**
     * Confirm delete user
     */
  onDialogOkBtnClick() {
    const { typeModal, serviceCd } = this.state;
    const { auth, dispatch } = this.props;
    if (typeModal == SELECT_TARGET_DATA.CSV) {
      this.exportCSV();
    } else {
      this.props.dispatch(
        editServiceDistribution(auth, DISTRIBUTION_EDIT_TYPE.delete, serviceCd, null),
      );
    }
    this.setState({ showModal: false, typeModal: null });
  }

  exportCSV() {
    const { offerType } = this.state.searchInfo;
    if (offerType === DISTRIBUTION_OFFER_TYPE.CONTENT) {
      this.getContentsList(SELECT_TARGET_DATA.CSV);
    } else if (offerType === DISTRIBUTION_OFFER_TYPE.COURSE) {
      this.getCourseList(SELECT_TARGET_DATA.CSV);
    }
  }

  /**
 * Handle event when click on header of table, call API to sort data
 *
 * @param row
 */
  handleSortState(row) {
    if (!this.validation()) {
      return;
    }
    const { searchInfo } = this.state;
    const { offerType } = searchInfo;
    searchInfo.ascendingDescendingSort = row.sortState;
    if (offerType === DISTRIBUTION_OFFER_TYPE.CONTENT) {
      searchInfo.distributionContentSortType = row.sortBy;
    } else if (offerType === DISTRIBUTION_OFFER_TYPE.COURSE) {
      searchInfo.distributionCourseSortType = row.sortBy;
    }
    this.setState(
      {
        searchInfo,
      },
      () => {
        this.getDistributionList();
      },
    );
  }

  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }

  render() {
    const canAccess = canAccessRoute(functionConstants.CONTENT_DISTRIBUTION_OFFER_LIST_EDIT);
    this.refsToValidate = [];
    const {
      distributionContentList,
      recordContentNum,
      serviceCd,
      serviceName,
      distributionStatus,
      distributionCourseList,
      recordCourseNum,
      searchInfo,
    } = this.state;
    const { offerType } = searchInfo;
    const editLink = Path.CONTENT_DISTRIBUTION_OFFER_LIST_EDIT.replace(':id', serviceCd);
    let renderActionType = null;
    let recordNum = 0;
    let distributionList = [];
    if (offerType === DISTRIBUTION_OFFER_TYPE.CONTENT) {
      recordNum = recordContentNum;
      distributionList = distributionContentList;
      renderActionType = (
        <DistributionOfferListDetailContentType
          {...searchInfo}
          distributionContentList={distributionContentList}
          recordNum={recordContentNum}
          startPosition={searchInfo && searchInfo.startPosition ? searchInfo.startPosition : 0}
          getStartEndData={this.getStartEndData.bind(this)}
          onInputChange={this.handleInputChange.bind(this)}
          handleSortState={this.handleSortState}
          onExportBtnClick={this.openConfirmDialog.bind(
            this,
            MessageTemplate.BULK_EXPORT,
            null,
            SELECT_TARGET_DATA.CSV,
          )}
          dataSort={this.state.searchInfo}
          onSearchBtnClick={this.handleSearchBtnClick.bind(this)}
          distributionStartDate={searchInfo && searchInfo.distributionStartDate ? searchInfo.distributionStartDate : ''}
          distributionEndDate={searchInfo && searchInfo.distributionEndDate ? searchInfo.distributionEndDate : ''}
          contentSecernId={searchInfo.contentSecernId}
          contentName={searchInfo.contentName}
          contentType={searchInfo.contentType}
          ref={(ref) => {
            if (ref) {
              this.refsToValidate.push(ref);
            }
          }}
        />
      );
    } else {
      recordNum = recordCourseNum;
      distributionList = distributionCourseList;
      renderActionType = (
        <DistributionOfferListDetailCourseType
          distributionCourseList={distributionCourseList}
          recordNum={recordCourseNum}
          startPosition={searchInfo.startPosition || 0}
          getStartEndData={this.getStartEndData.bind(this)}
          onInputChange={this.handleInputChange.bind(this)}
          handleSortState={this.handleSortState}
          onExportBtnClick={this.openConfirmDialog.bind(
            this,
            MessageTemplate.BULK_EXPORT,
            null,
            SELECT_TARGET_DATA.CSV,
          )}
          dataSort={this.state.searchInfo}
          onSearchBtnClick={this.handleSearchBtnClick.bind(this)}
          distributionStartDate={searchInfo && searchInfo.distributionStartDate ? searchInfo.distributionStartDate : ''}
          distributionEndDate={searchInfo && searchInfo.distributionEndDate ? searchInfo.distributionEndDate : ''}
          courseName={searchInfo.courseName}
          ref={(ref) => {
            if (ref) {
              this.refsToValidate.push(ref);
            }
          }}
        />
      );
    }

    return (
      <Col sm={12}>
        <CustomLink
          className="margin-right-7 url-list"
          to={Path.CONTENT_DISTRIBUTION_LIST}
          text="コンテンツ配布管理に戻る"
          icon="bi bi-chevron-left"
        />
        <MessageSearch
          recordNum={recordNum}
          resultList={distributionList}
          isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
          dismissMessage={this.dismissMessage}
        />
        <Header name="コンテンツ配布先情報の詳細" />
        <DistributionOfferListDetailTitle
          serviceName={serviceName}
          distributionStatus={distributionStatus}
          offerType={offerType}
          doStartStopContent={this.handleStartStopContent.bind(this)}
          onInputChange={this.handleInputChange.bind(this)}
          onHandleOfferTypeChange={this.handleOfferTypeChange.bind(this)}
        />
        {renderActionType}
        <Col sm={12} className="text-center margin-top-20">
          {/* <Button bsStyle="primary" className="btn-96 margin-10" onClick={this.handleBackBtnClick.bind(this)}>
            戻る
          </Button> */}
          {canAccess ?
            <LinkContainer to={editLink} className="btn-96">
              <Button variant="primary" className="btn-96 margin-10">
                編集
              </Button>
            </LinkContainer> : null}
          {canAccess ?
            <Button variant="primary" className="btn-96 margin-10" onClick={this.openConfirmDialog.bind(this, MessageTemplate.MSG_DEL_DISTRIBUTION, null, null)}>
              削除
            </Button> : null}
        </Col>
        <DialogConfirm
          showModal={this.state.showModal}
          onCancel={this.onDialogCancelBtnClick}
          mdSize={this.mdSize}
          content={this.content}
          onOK={this.onDialogOkBtnClick}
        />
      </Col>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { parentPathSub, searchConditionSub } = state.page;
  return ({
    contentDistribution: state.contentDistribution,
    auth: state.authed.authedUser,
    ...{ redirectToList: state.contentDistribution.redirectToList },
    parentPathSub,
    searchConditionSub,
  });
};
export default connect(mapStateToProps)(DistributionOfferListDetailContainer);
